// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountsRequestModel {
    static getAttributeTypeMap() {
        return SiteAccountsRequestModel.attributeTypeMap;
    }
}
SiteAccountsRequestModel.discriminator = undefined;
SiteAccountsRequestModel.additionalProperties = false;
SiteAccountsRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
];
//# sourceMappingURL=siteAccountsRequestModel.js.map